"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectDropdown = void 0;
var react_1 = __importDefault(require("react"));
var setDropdownSelectText_1 = require("../../utils/setDropdownSelectText");
var Caret_1 = require("../Caret");
var genIcon_1 = require("../../utils/genIcon");
var Typo_1 = require("../../../Typo");
var styled_1 = require("./styled");
var genColor_1 = require("../../utils/genColor");
var SelectDropdown = function (_a) {
    var 
    //from root
    invert = _a.invert, value = _a.value, placeholder = _a.placeholder, genCustomSelectComp = _a.genCustomSelectComp, selectClassName = _a.selectClassName, 
    //from Dropdown
    showOptions = _a.showOptions, 
    //used only for filters, where we dont remove the placeholder even when an option is selected, instead we sustain the blue underline
    // && header where we dont update the menu title if one of its options is selected
    disableSelectTextUpdate = _a.disableSelectTextUpdate, _b = _a.selectConfig, selectConfig = _b === void 0 ? "all" : _b, selectStyleOverride = _a.selectStyleOverride, //used curr only in access control table & header dropdowns
    S = _a.S, disabled = _a.disabled;
    var dropdownSelectText = (0, setDropdownSelectText_1.setDropdownSelectText)({
        placeholder: placeholder,
        disableSelectTextUpdate: disableSelectTextUpdate,
        value: value,
        isTagsStyle: false,
    });
    var showElem = function (elem) {
        if (selectConfig === "all")
            return true;
        //else
        return selectConfig.indexOf(elem) !== -1 ? true : false;
    };
    var TypoComp = S ? Typo_1.SANS_2 : Typo_1.SANS_3;
    var genSelectComp = function () { return (react_1.default.createElement(styled_1.StyledSelectWrapper, { invert: invert, S: S, disabled: disabled, style: selectStyleOverride },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { style: { display: "flex", gap: "1rem", alignItems: "center" } },
                showElem('color') && (0, genColor_1.genColor)({ color: value === null || value === void 0 ? void 0 : value.color }),
                showElem("icon") && (0, genIcon_1.genIcon)({ icon: value === null || value === void 0 ? void 0 : value.icon, invert: invert, S: S }),
                showElem("display") && (react_1.default.createElement(TypoComp
                // semibold={
                //   dropdownSelectText.desc && showElem("desc") ? true : undefined
                // }
                , { 
                    // semibold={
                    //   dropdownSelectText.desc && showElem("desc") ? true : undefined
                    // }
                    className: "".concat(selectClassName || "", " ").concat(!value && placeholder) }, dropdownSelectText.display)))),
        react_1.default.createElement(Caret_1.Caret, { showOptions: showOptions, invert: invert, disabled: disabled }))); };
    return genCustomSelectComp ? genCustomSelectComp() : genSelectComp();
};
exports.SelectDropdown = SelectDropdown;
